module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-700.957e93fbbe131a59791cd820d98b7109.woff";